import get from 'lodash/get';

export const textInputStyle = (theme) => ({
  textField: {
    width: '100%',
  },
  textFieldInput: {
    backgroundColor: theme.palette.background.default,
    ...theme.typography.body1,
    ...get(theme, 'overrides.MuiTypography.body1', {}),
  },
});
